import React, { Component, Fragment } from 'react';
import Menu from '@tencent/dui/lib/components/Menu';
import Tabs from '@tencent/dui/lib/components/Tabs';
import Badge from '@tencent/dui/lib/components/Badge';
import ScaleSlide from '@editor/src/page/index/components/canvas/scale-slide';
import { observer } from 'mobx-react';
import { SlideSizeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-size/slide-size.interface';
import { RenderPostionType } from '../../../../../js/constant';
import { findDOMNode } from 'react-dom';
import i18n from '@i18next/i18n';
import styles from './template-grid-menu.less';
import classNames from 'classnames';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import ImportTemplateAddon from './template-import-addon';
import { getPptAddLayout, getPptAddItems } from './utils';
import RecommendAddItem, { getReportSourceType } from './recommend-add-item';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { IMasterDataModel } from '@tencent/slide-sdk-model';
import { SupportingLayout } from '@com/tool-bar/menu/supporting-layout';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { RECOMMEND_TAB_IDS } from '@com/tool-bar/toolbar-grid-menu.interface';

interface TemplateGridMenuProps {
    id?: string;
    columns: number;
    onGridClick?: () => void;
    onMenuClick: () => void;
    masterList: any[];
    showSelected: boolean;
    needShowRecommendLayouts: boolean;
    handleClickCB: () => void;
    activeTabId?: RECOMMEND_TAB_IDS  // props 传了 activeTabId 表示由外部控制 Tabs 变化，没有则由组件内部自己控制。
    onTabChange?: (tabId: RECOMMEND_TAB_IDS) => void
}

interface TemplateGridMenuState {
    firstRenderCount: number;
    recommendAddLayouts: any[] | null;
    showRedPoint: boolean;
    showTemplate: boolean;
    activeTabId: RECOMMEND_TAB_IDS; // 控制 <Tabs> 组件的参数
}

const RENDER_COUNT = 3;
const TEMPLATE_ACTIVE_TAB_ID = 'template_active_tab_id';

const tabList = [
    {
        title: i18n.t('封面'),
        id: RECOMMEND_TAB_IDS.COVER,
    },
    {
        title: i18n.t('目录'),
        id: RECOMMEND_TAB_IDS.CONTENTS,
    },
    {
        title: i18n.t('章节'),
        id: RECOMMEND_TAB_IDS.CHAPTER,
    },
    {
        title: i18n.t('正文'),
        id: RECOMMEND_TAB_IDS.TEXT,
    },
    {
        title: i18n.t('结尾'),
        id: RECOMMEND_TAB_IDS.END,
    },
];

@observer
class TemplateGridMenu extends Component<TemplateGridMenuProps, TemplateGridMenuState> {
    public static defaultProps = {
        columns: 1,
        onMenuClick() {},
        handleClickCB() {},
        showSelected: false,
        needShowRecommendLayouts: false,
    };
    private maxCount: number;
    private unMount: boolean;
    private menuDom: any;
    private timer;
    public constructor(props: TemplateGridMenuProps) {
        super(props);

        this.state = {
            showTemplate: false,
            firstRenderCount: RENDER_COUNT,
            recommendAddLayouts: null,
            showRedPoint: this.getInitRedPointShowState(),
            activeTabId: RECOMMEND_TAB_IDS.BASE,
        };

        let count = 0;

        const masters = props.masterList;
        masters?.forEach((master) => {
            master.layoutList.map(() => count += 1);
        });
        this.maxCount = count;
        this.unMount = false;
    }

    public render() {
        const { props } = this;
        const { recommendAddLayouts, showRedPoint, showTemplate, activeTabId } = this.state;
        const masters = this.props.masterList;
        const templateWidth = 128;
        let templateHeight = 72;

        let ratio = 1;
        const sizeType = this.getUiDataService().presentation.props.slideSizeType;
        const { slideWidth, slideHeight } = this.getUiDataService().presentation.props;
        if (sizeType === SlideSizeType.SLIDE_SIZE_4_3) {
            ratio = 3 / 4;
        } else if (sizeType === SlideSizeType.SLIDE_SIZE_16_9) {
            ratio = 9 / 16;
        } else {
            ratio = slideHeight / slideWidth;
        }
        templateHeight = templateWidth * ratio;

        const containerPadding = 5;
        const containerMarginRight = 4;
        const containerWidth = templateWidth + (2 * containerPadding);
        const containerHeight = templateHeight + (2 * containerPadding) + 20;

        const menuPadding = 14;
        const rowWidth = (containerWidth + containerMarginRight) * props.columns; // 写死每行的宽度，否则在使用鼠标时由于滚动条出现，导致每行只能显示2列
        const menuWidth = rowWidth + (2 * menuPadding) + 2; // 此处的2是微调，否则会排列错误
        let menuHeight = 460;

        if (document.body.clientHeight < 730) {
            menuHeight = document.body.clientHeight * 0.66;
        }
        let renderCount = 0;
        const getNormalLayoutsNodeList = masters?.map((master, masterIndex) => (
            <div key={master.key} style={{ width: rowWidth }}>
                <div className={styles.themeName} style={{ marginLeft: containerPadding }}>
                    {TENANT_CONFIG.TENANT_DOC_NAME
                        ? i18n.t(master.themeName?.replace(/\u200B/g, '')?.replace(/腾讯文档/g, TENANT_CONFIG.TENANT_DOC_NAME))
                        : i18n.t(master.themeName?.replace(/\u200B/g, ''))}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>{master.layoutList.map((layout, layoutIndex) => {
                    renderCount += 1;
                    const marginTop = layoutIndex < props.columns ? '10px' : '6px';
                    const isLastLayout = (layoutIndex + 1) % props.columns === 0;
                    const itemStyle: React.CSSProperties = {
                        display: 'block',
                        height: containerHeight,
                        width: containerWidth,
                        padding: containerPadding,
                        position: 'relative',
                        marginTop,
                        marginRight: isLastLayout ? 0 : containerMarginRight,
                        boxSizing: 'border-box',
                        verticalAlign: 'top',
                    };
                    if (props.showSelected
                        && this.getSelectionService().currentSlide?.layoutId === layout.id) {
                        itemStyle.backgroundColor = 'rgba(51, 77, 102, 0.08)';
                    }
                    const layoutId = `${masterIndex}.${layoutIndex}`;
                    const layoutName = i18n.t(layout.name);
                    const shouldRenderLayout = layout.childrenConverted
                        && renderCount <= this.state.firstRenderCount;
                    return (
                        <div className={styles.layoutContainer} key={layout.key}>
                            <Menu.Item id={layoutId} style={itemStyle}>
                                {/* 此处改为幻灯片缩略图 */}
                                {/* <img className={styles.templateGrid} src={itemData.icon}/> */}
                                {shouldRenderLayout ? (
                                    <ScaleSlide
                                        width={templateWidth}
                                        height={templateHeight}
                                        slideModel={layout}
                                        shouldUpdate={false}
                                        isTemplate={true}
                                        region={RenderPostionType.TEMPLATE} />
                                ) : null}
                                <div className={styles.layoutName}>{layoutName}</div>
                            </Menu.Item>
                        </div>
                    );
                })}</div>
            </div>
        ));

        const insertLayoutList = tabList.map((tabInfo, tabIndex) => {
            const recommendList = this.getRecommendGroupNodes(recommendAddLayouts?.[tabIndex], tabInfo.id);
            return <Tabs.TabPane key={tabInfo.id} style={{ marginTop: 8 }} tab={tabInfo.title} id={tabInfo.id}>
                {
                    recommendList
                }
            </Tabs.TabPane>;
        });

        insertLayoutList.unshift(<Tabs.TabPane style={{ marginTop: 8 }} tab={i18n.t('基础')} id={RECOMMEND_TAB_IDS.BASE}>
            {getNormalLayoutsNodeList}
        </Tabs.TabPane>);

        const showMallTemplate = this.showMallTemplate();

        if (showMallTemplate) {
            insertLayoutList.unshift(<Tabs.TabPane
                forceRender={true}
                style={{ marginTop: 8 }}
                tab={i18n.t('配套版式')}
                id={RECOMMEND_TAB_IDS.TEMPLATE}>
                <SupportingLayout
                    containerHeight={containerHeight}
                    containerWidth={containerWidth}
                    templateHeight={templateHeight}
                    templateWidth={templateWidth}
                    containerPadding={containerPadding}
                    containerMarginRight={containerMarginRight}
                    rowWidth={rowWidth}
                    columns={props.columns}
                    onMenuClick={props.handleClickCB}
                />
            </Tabs.TabPane>);
        }

        return (
            <div
                onClick={() => {
                    props.onGridClick?.();
                }}
                className='template-grid-menu-container'
                id={this.props.id}
            >
                <Menu
                    className={classNames({
                        ['menu-scroll']: true,
                        [styles['template-grid-menu']]: true,
                    })}
                    ref={(ref) => {
                        this.menuDom = ref;
                    }}
                    style={{
                        width: menuWidth,
                        height: menuHeight,
                        overflowX: 'hidden',
                        padding: menuPadding,
                        paddingTop: 6,
                        boxSizing: 'border-box',
                    }}
                    onClick={props.onMenuClick}
                    onWheel={this.handleWheel}
                >
                    {
                        this.props.needShowRecommendLayouts ? <Tabs
                            activeId={this.props.activeTabId ?? activeTabId}
                            alignment="left"
                            tabBarStyle={{
                                borderBottom: '1px solid #f1f1f1',
                            }}
                            tabBarContainerStyle={{
                                width: 340,
                            }}
                            tabBarSize="medium"
                            className={styles['recommend-tabs-bar-container']}
                            tabBarItemClassName={styles['recommend-tabs-bar-item']}
                            onChange={this.handleTabChange}
                            onClickTabBarContainer={this.handleDropdownKeep}
                        >
                            {
                                insertLayoutList
                            }
                        </Tabs> : getNormalLayoutsNodeList
                    }
                    { this.props.needShowRecommendLayouts ? <ImportTemplateAddon
                        handleClickCB={this.props.handleClickCB} /> : null}
                </Menu>
            </div>
        );
    }

    public componentDidMount() {
        if (this.menuDom) {
            // 确保第一次dom元素真正挂载成功，否则react有可能把这次挂载和上次合并。
            // eslint-disable-next-line react/no-find-dom-node
            const menu = findDOMNode(this.menuDom);
            const rect = (menu as Element).getBoundingClientRect();
            const w = rect.width;
            if (w > 0) {
                this.loadItemDelay(this.state.firstRenderCount, 200);
            }
        } else {
            this.loadItemDelay(this.state.firstRenderCount, 200);
        }
        if (this.props.needShowRecommendLayouts) {
            this.initRecommendAddLayouts();
            this.tdwReportTabShowLog(this.getDefaultTabId(this.showMallTemplate()));
        }

        // 设置组件初始的 activeTabId
        const showMallTemplate = this.showMallTemplate();
        const defaultActiveTabId: RECOMMEND_TAB_IDS = this.props.needShowRecommendLayouts
            ? this.getDefaultTabId(showMallTemplate) as RECOMMEND_TAB_IDS : RECOMMEND_TAB_IDS.BASE;
        this.setState({ activeTabId: defaultActiveTabId });
    }

    public componentWillUnmount() {
        if (this.timer) {
            this.unMount = true;
            clearTimeout(this.timer);
        }
    }

    // 红点引导，2023-12-15 00:00:00  过期删除
    private getInitRedPointShowState = (): boolean => {
        const enableShowRedPoint = getToggleStatusByType(ToggleType.SLIDE_ADD_PAGE_RED_POINT, false);
        if (!enableShowRedPoint) {
            return false;
        }
        return !userLocalStorage.getItem(LocalStorageKeys.SLIDE_ADD_PAGE_CONTENT);
    };

    private async initRecommendAddLayouts() {
        const layouts = await getPptAddLayout();
        const topicIdsArr = layouts.map(layout => layout.map(topic => topic.topicId));
        const topicDetailsPromise = Promise.all(topicIdsArr.map(topicIds => getPptAddItems(topicIds)));
        const topicDetails = await topicDetailsPromise;
        this.setState({
            recommendAddLayouts: topicDetails,
        });
    }

    private loadItemDelay = (curCount: number, delay: number) => {
        if (curCount > this.maxCount || this.unMount) return;
        curCount += RENDER_COUNT;
        this.timer = setTimeout(() => {
            this.timer = null;
            this.setState({
                firstRenderCount: curCount,
            }, () => {
                this.loadItemDelay(curCount, 0);
            });
        }, delay);
    };

    private getSelectionService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer.selectionService;
    }

    private getChangeTemplateService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .editableServiceLayer?.changeTemplateService;
    }

    private getUiDataService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .getUiDataService();
    }

    private getRecommendGroupNodes(recommendAddLayouts: any[], tabId: string) {
        return recommendAddLayouts
            ? recommendAddLayouts.map(recommendAddLayout => <div key={recommendAddLayout.topic.id}>
                <span className={styles['recommend-title'] } onClick={this.handleDropdownKeep}>{recommendAddLayout.topic.name}</span>
                <div className={styles['recommend-container']}>
                    {this.getItemsWithPrices(recommendAddLayout, tabId).map(item => <RecommendAddItem
                        key={item.id}
                        item={item}
                        containerRef={this.menuDom}
                        handleClickCB={this.props.handleClickCB}/>)}
                </div>
            </div>) : null;
    }

    // prices信息拼接到Item基本信息上
    private getItemsWithPrices(recommendAddLayout: any, tabId: string) {
        const { items, prices, topic } = recommendAddLayout;
        return items.map((item, index) => {
            // 一般顺序是一致的，直接取就行
            if (item.id === prices[index].itemId) {
                return { ...item, ...prices[index], topicId: topic.id, tabId };
            }
            // 万一碰到不一致的就找一下
            return { ...item, ...prices.find(p => p.itemId === item.id) };
        }).sort((a, b) => a.id.localeCompare(b.id));
    }

    // 当前会话缓存tabId，下次打开使用
    private handleTabChange = (tabId: RECOMMEND_TAB_IDS) => {
        sessionStorage.setItem(TEMPLATE_ACTIVE_TAB_ID, tabId);
        this.tdwReportTabShowLog(tabId);
        if (tabId === RECOMMEND_TAB_IDS.TEXT && this.state.showRedPoint) {
            this.setState({
                showRedPoint: false,
            });
            userLocalStorage.setItem(LocalStorageKeys.SLIDE_ADD_PAGE_CONTENT, true);
        }
        if (this.props.activeTabId) {
            this.props?.onTabChange?.(tabId);
        } else {
            this.setState({ activeTabId: tabId });
        }
    };

    private tdwReportTabShowLog = (tabId: string) => {
        // 产品tab展示的上报
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.ADD_PAGE,
            action: tabId,
        });

        if (tabId !== RECOMMEND_TAB_IDS.BASE) {
            // 商城上报模板页曝光量
            tdw({
                opername: TDWOperationType.DOC_TEMPLATE_WEB,
                module: TDWModuleType.TEMPLATE_MALL,
                action: TDWActionType.TEMPLATE_MALL_PAGE_VIEW,
                file_type: 4, // ppt
                source3: 'doc_ppt_recommend_reco', // fromPage
                ver9: 'doc_ppt_recommend_reco', // fromPage
                ver5: getReportSourceType(tabId),
            });
        }
    };

    private getDefaultTabId = (showMallTemplate: boolean): string => {
        let cacheId = sessionStorage.getItem(TEMPLATE_ACTIVE_TAB_ID);
        if (!showMallTemplate && cacheId === RECOMMEND_TAB_IDS.TEMPLATE) {
            cacheId = RECOMMEND_TAB_IDS.BASE;
        }

        return cacheId || (showMallTemplate ? RECOMMEND_TAB_IDS.TEMPLATE : RECOMMEND_TAB_IDS.BASE);
    };

    private handleDropdownKeep = (e: React.MouseEvent) => {
        Dropdown.Keep.useKeep(e.nativeEvent);
    };

    private handleWheel = (e: React.WheelEvent) => {
        e.nativeEvent.stopPropagation();
    };

    private showMallTemplate = () => {
        const { currentSlide } = this.getSelectionService();
        const masterDataModel = currentSlide?.getRelationMasterModel().sdkData as IMasterDataModel;

        // todo: 母版的cSld.name语义上不应该存模版id（不过目的没地用这个name），但是自定义ooxml还没开发完成，暂时代餐，开发完了一定要切成自定义字段
        return !!masterDataModel?.props.cSld.name;
    };

    private getLayout = (options: {
        rowWidth: number;
        containerPadding: number;
        containerMarginRight: number;
        containerHeight: number;
        containerWidth: number;
        templateWidth: number;
        templateHeight: number;
        templateId: string;
    }) => {
        const {
            rowWidth,
            containerPadding,
            containerMarginRight,
            containerWidth,
            containerHeight,
            templateWidth,
            templateHeight,
            templateId,
        } = options;
        const { props } = this;

        const templateMasterList: IMasterModel[] = [];

        const getNormalLayoutsNodeList = templateMasterList.map((master, masterIndex) => {
            const a = 1;
            return <div key={master.key} style={{ width: rowWidth }}>
                {/* <div className={styles.themeName} style={{ marginLeft: containerPadding }}>*/}
                {/*    {i18n.t(master.themeName?.replace(/\u200B/g, ''))}*/}
                {/* </div>*/}
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>{master.layoutList.map((layout, layoutIndex) => {
                    const marginTop = layoutIndex < props.columns ? '10px' : '6px';
                    const isLastLayout = (layoutIndex + 1) % props.columns === 0;
                    const itemStyle: React.CSSProperties = {
                        display: 'block',
                        height: containerHeight,
                        width: containerWidth,
                        padding: containerPadding,
                        position: 'relative',
                        marginTop,
                        marginRight: isLastLayout ? 0 : containerMarginRight,
                        boxSizing: 'border-box',
                        verticalAlign: 'top',
                    };
                    if (props.showSelected
                        && this.getSelectionService().currentSlide?.layoutId === layout.id) {
                        itemStyle.backgroundColor = 'rgba(51, 77, 102, 0.08)';
                    }
                    const layoutId = `${masterIndex}.${layoutIndex}`;
                    const layoutName = i18n.t(layout.name);
                    const shouldRenderLayout = true;
                    return (
                        <div className={styles.layoutContainer} key={layout.key}>
                            <Menu.Item id={layoutId} style={itemStyle}>
                                {/* 此处改为幻灯片缩略图 */}
                                {/* <img className={styles.templateGrid} src={itemData.icon}/> */}
                                {shouldRenderLayout ? (
                                    <ScaleSlide
                                        width={templateWidth}
                                        height={templateHeight}
                                        slideModel={layout}
                                        shouldUpdate={false}
                                        isTemplate={true}
                                        region={RenderPostionType.TEMPLATE} />
                                ) : null}
                                <div className={styles.layoutName}>{layoutName}</div>
                            </Menu.Item>
                        </div>
                    );
                })}</div>
            </div>;
        });

        return getNormalLayoutsNodeList;
    };
}

export default TemplateGridMenu;
